export default __webpack_public_path__ + "static/banner-5-dog-breeds-with-low-bellies-a246437d81166474e1897b53652b73f5.jpg";